// // // import React from 'react';
// // // import { Link } from 'react-router-dom';

// // src/components/Navbar.js
// import React, { useContext } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { AuthContext } from '../context/AuthContext';

// function Navbar() {
//   const { isAuthenticated, setIsAuthenticated } = useContext(AuthContext);
//   const navigate = useNavigate();

//   const handleLogout = async () => {
//     try {
//       await axios.get(`${process.env.REACT_APP_API_BASE_URL}/auth/logout`, { withCredentials: true });
//       setIsAuthenticated(false);
//       navigate('/login'); // Redirect to login page after logout
//     } catch (err) {
//       console.error('Logout failed', err);
//     }
//   };

//   return (
//     <nav className="bg-white shadow mb-8">
//       <div className="max-w-7xl mx-auto px-4">
//         <div className="flex justify-between items-center py-4">
//         <div className="flex items-center space-x-2">
//             {/* If your logo is in public, you can do src="/logo.png" */}
//             <img
//               src="android-chrome-512x512.png"
//               alt="Critical Cases Logo"
//               className="h-8 w-8" 
//             />
//             <Link to="https://criticalcases.com" className="text-2xl font-bold text-gray-900 no-underline">
//               Critical Cases
//             </Link>
//           </div>
//           {/* <Link to="/" className="text-2xl font-bold text-gray-900 no-underline">Critical Cases</Link> */}
//           <div className="space-x-4">
//           {isAuthenticated && (
//               <Link to="/dashboard" className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition no-underline">
//                 Dashboard
//               </Link>
//             )}
//           {isAuthenticated && (
//               <button>
//                 <Link to="/guide" className="px-6 py-3 bg-[#9f74ed] text-white rounded-lg hover:bg-[#8a51f0] transition no-underline">Guide</Link>
//               </button>
//             )}

//             {!isAuthenticated && (
//               <>
//                 <Link to="/demo" className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition no-underline">Demo</Link>
//                 <Link to="/login" className="px-6 py-3 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition no-underline">Login</Link>
//                 {/* <Link to="/register" className="text-gray-700 hover:text-blue-600 transition">Register</Link> */}
//                 {/* <Link to="/guide" className="px-6 py-3 bg-[#9f74ed] text-white rounded-lg hover:bg-[#8a51f0] transition no-underline">Guide</Link> */}
//               </>
//             )}
//             {isAuthenticated && (
//               <button
//                 onClick={handleLogout}
//                 className="px-6 py-3 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition no-underline"
//               >
//                 Logout
//               </button>
//             )}
//           </div>
//         </div>
//       </div>
//     </nav>
//   );
// }

// export default Navbar;

import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../context/AuthContext';

function Navbar() {
  const { isAuthenticated, setIsAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await axios.get(`${process.env.REACT_APP_API_BASE_URL}/auth/logout`, { withCredentials: true });
      setIsAuthenticated(false);
      navigate('/login');
    } catch (err) {
      console.error('Logout failed', err);
    }
  };

  return (
    <nav className="bg-white shadow sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between items-center py-4">
          {/* Logo and Title */}
          <div className="flex items-center space-x-2">
          <Link to="https://criticalcases.com" className="text-2xl font-bold text-gray-900 no-underline">
            <img
              src="android-chrome-512x512.png"
              alt="Critical Cases Logo"
              className="h-8 w-8"
            />
          </Link>
            <Link to="https://criticalcases.com" className="text-2xl font-bold text-gray-900 no-underline">
              Critical Cases
            </Link>
          </div>

          {/* Hamburger Menu for All Screen Sizes */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="text-gray-700 focus:outline-none"
          >
            <svg
              className="h-6 w-6"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Menu Items */}
        {isMenuOpen && (
          <div className="mt-4 space-y-2 text-center">
            {isAuthenticated && (
              <Link
                to="/dashboard"
                className="block px-6 py-2 w-full max-w-[200px] bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition mx-auto no-underline"
              >
                Dashboard
              </Link>
            )}
            {isAuthenticated && (
              <Link
                to="/guide"
                className="block px-6 py-2 w-full max-w-[200px] bg-[#9f74ed] text-white rounded-lg hover:bg-[#8a51f0] transition mx-auto no-underline"
              >
                Guide
              </Link>
            )}

            {!isAuthenticated && (
              <>
                <Link
                  to="/demo"
                  className="block px-6 py-2 w-full max-w-[200px] bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition mx-auto no-underline"
                >
                  Demo
                </Link>
                <Link
                  to="/login"
                  className="block px-6 py-2 w-full max-w-[200px] bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition mx-auto no-underline"
                >
                  Login
                </Link>
              </>
            )}

            {isAuthenticated && (
              <button
                onClick={handleLogout}
                className="block px-6 py-2 w-full max-w-[200px] bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition mx-auto no-underline"
              >
                Logout
              </button>
            )}
          </div>
        )}
      </div>
    </nav>
  );
}

export default Navbar;
